





































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import SubscriptionPricingTable from '@/components/subscriptions/SubscriptionPricingTable.vue'

@Component({
    components: {
        SubscriptionPricingTable
    }
})
export default class LandingHomeView extends Vue {
    onRegisterOrLoginPressed() {
        console.log('Login Pressed')
        // TODO: for some reason this doesn't work, the page doesn't load
        // this.$router.push(RoutePaths.PORTAL_HOME)
        this.$router.push('/portal')
    }
}
